import { ctaClick } from "@wix/bi-logger-marketing-data/v2";
import { useBILogger } from "@wix/fe-essentials-standalone";
import {
  picassoUserClickSrc184Evid1,
  picassoGenericModalViewSrc184Evid4,
} from "@wix/bi-logger-picasso-data/v2";
import type {
  picassoUserClickSrc184Evid1Params,
  picassoGenericModalViewSrc184Evid4Params,
} from "@wix/bi-logger-picasso-data/v2/types";
import { PRODUCT_AREA, CHOOSE_DESIGN_PARTNER_BUTTON_NAME } from "./constants";
import type { Designer } from "@wix/ambassador-picasso-editor-v1-designer/types";

export const useBiLogger = () => {
  const biLogger = useBILogger();

  const trackUserClickMarketing = ({ ctaName }: { ctaName: string }) =>
    biLogger.report(ctaClick({ ctaName }));

  const handleDesignStudioClick = (
    selectedDesignStudio: Designer | undefined,
  ) => {
    trackUserClickPicasso({
      buttonName: CHOOSE_DESIGN_PARTNER_BUTTON_NAME,
      value: selectedDesignStudio?.id ?? undefined,
    });
  };

  const handleGenericModalView = (
    data: picassoGenericModalViewSrc184Evid4Params,
  ) => {
    biLogger.report(
      picassoGenericModalViewSrc184Evid4({
        ...data,
        productArea: PRODUCT_AREA.HOME_PAGE,
      }),
    );
  };

  const trackUserClickPicasso = (data: picassoUserClickSrc184Evid1Params) =>
    biLogger.report(
      picassoUserClickSrc184Evid1({
        ...data,
        productArea: PRODUCT_AREA.HOME_PAGE,
      }),
    );

  return {
    trackUserClickMarketing,
    trackUserClickPicasso,
    handleDesignStudioClick,
    handleGenericModalView,
  };
};
